export default __webpack_public_path__ + "static/media/academic-chair.a4babe85.png";